"use client";

import Image from "next/image";
import { motion, useReducedMotion, type Variants } from "framer-motion";
import sharedStyles from "../shared/Layout.module.css";
import styles from "./ElectionTimeline.module.css";
import type { ElectionStage } from "@/app/about/elections/data";

type ElectionTimelineProps = {
  stages: ElectionStage[];
};

const stageCardVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 14,
  },
  visible: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.07,
      duration: 0.66,
      ease: [0.16, 1, 0.3, 1],
    },
  }),
};

export default function ElectionTimeline({ stages }: ElectionTimelineProps) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <section className={styles.timelineSection}>
      <div className={sharedStyles.container}>
        <div className={styles.timelineTrack}>
          <div className={styles.trackLine} aria-hidden="true" />
          {stages.map((stage, index) => (
            <motion.article
              key={stage.id}
              className={styles.stageCard}
              variants={stageCardVariants}
              initial={shouldReduceMotion ? false : "hidden"}
              whileInView={shouldReduceMotion ? undefined : "visible"}
              viewport={{ once: true, amount: 0.35 }}
              custom={index}
            >
              <div className={styles.stageIconWrap}>
                <Image
                  src={stage.icon}
                  alt={stage.iconAlt}
                  width={18}
                  height={18}
                  className={styles.stageIcon}
                />
              </div>
              <span className={styles.stageIndex}>{stage.id}</span>
              <h2 className={styles.stageTitle}>{stage.title}</h2>
              <p className={styles.stageText}>{stage.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
